module.exports = __webpack_public_path__ + "static/media/28DGC4.287e28c3.jpg";